export default __webpack_public_path__ + "static/media/grey-denmark-map.0ab9facc.svg";